import React, { useRef } from 'react';
import {
  string,
  number,
  node,
  arrayOf,
  oneOfType
} from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';
import {
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayOfType
} from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

export const ProductLoader = (props) => {
  const {
    itemId,
    storeId: propStoreId,
    domains,
    children
  } = props;
  const storeId = propStoreId || useStoreId();
  const loadedStoreId = useRef(storeId);
  const resp = useProductDeprecated({ itemId, storeId, domains });
  if (resp.data && !resp.loading) {
    loadedStoreId.current = resp.variables?.storeId || storeId;
  }
  return children(resp, loadedStoreId.current);
};

ProductLoader.displayName = 'ShareBeltProductLoader';

ProductLoader.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    info: shapeType({
      fiscalYear: stringType(),
      productDepartment: stringType(),
      classNumber: stringType()
    })
  })
};

ProductLoader.propTypes = {
  children: node.isRequired,
  domains: arrayOf(string).isRequired,
  itemId: oneOfType([string, number]).isRequired,
  storeId: string
};

ProductLoader.defaultProps = {
  storeId: ''
};

export default ProductLoader;
